export default __webpack_public_path__ + "static/media/blackPlus.dcc007fe.svg";